// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1%;
}
.how__main .how_top_section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.how__main .how_top_section h2 {
  font-size: 3rem;
}
.how__main .how_top_section h2 span {
  color: #e63b11;
}
.how__main .how_top_section h6 {
  font-weight: 400;
  font-size: 1.8rem;
  margin: 0 auto;
}
.how__main .how_top_section .how_top_section_row {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 50%;
  color: #e63b11;
  margin: 1% auto;
}
.how__main .how_top_section .how_top_section_row h3 {
  text-transform: uppercase;
  font-size: 1.9rem;
}
@media (min-width: 691px) and (max-width: 850px) {
  .how__main .how_top_section h2 {
    font-size: 2rem;
  }
  .how__main .how_top_section h6 {
    font-size: 1.2rem;
  }
  .how__main .how_top_section .how_top_section_row h3 {
    font-size: 1.3rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .how__main .how_top_section h2 {
    font-size: 2.3rem;
  }
  .how__main .how_top_section h6 {
    font-size: 1.5rem;
  }
  .how__main .how_top_section .how_top_section_row h3 {
    font-size: 1.5rem;
  }
}
@media (max-width: 690px) {
  .how__main .how_top_section {
    width: 90%;
    text-align: center;
  }
  .how__main .how_top_section h2 {
    font-size: 1.8rem;
  }
  .how__main .how_top_section h6 {
    font-size: 1.2rem;
  }
  .how__main .how_top_section .how_top_section_row {
    width: 90%;
  }
  .how__main .how_top_section .how_top_section_row h3 {
    font-size: 1.2rem;
  }
  .how__main .how_top_section .how_top_section_row .how_icon {
    font-size: 1rem;
  }
}
.how__main .how_instructions {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
}
.how__main .how_instructions .how_instructions_row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.how__main .how_instructions .how_instructions_row .how_row_text {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.how__main .how_instructions .how_instructions_row .how_row_text .text_row {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
}
.how__main .how_instructions .how_instructions_row .how_row_text .text_row .text_icon {
  font-size: 2.5rem;
}
.how__main .how_instructions .how_instructions_row .how_row_text .text_row h2 {
  color: #e63b11;
  margin-left: 2%;
  font-size: 2rem;
}
.how__main .how_instructions .how_instructions_row .how_row_text p {
  width: 70%;
  font-size: 1.2rem;
  margin-left: 12%;
}
.how__main .how_instructions .how_instructions_row .how_row_text ul {
  width: 50%;
  font-size: 1.2rem;
  margin-left: 12%;
}
.how__main .how_instructions .how_instructions_row img {
  width: 50%;
  filter: opacity(0.6);
}
.how__main .how_instructions .how_instructions_row:nth-child(even) {
  background-color: #f2f2f2;
  flex-direction: row-reverse;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .how__main .how_instructions .how_instructions_row .how_row_text p {
    font-size: 1.1rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text ul {
    font-size: 1.1rem;
  }
  .how__main .how_instructions .how_instructions_row img {
    height: 100%;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row h2 {
    font-size: 1.5rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row .text_icon {
    font-size: 2.2rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text p {
    font-size: 0.9rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text ul {
    font-size: 0.9rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row h2 {
    font-size: 1.7rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row .text_icon {
    font-size: 2.4rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text p {
    font-size: 1rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text ul {
    font-size: 1rem;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row {
    width: 95%;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row .text_icon {
    font-size: 2rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row h2 {
    font-size: 1.3rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text p {
    font-size: 0.9rem;
    width: 85%;
    margin-top: 0;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text ul {
    font-size: 0.85rem;
    width: 95%;
    margin-left: 5%;
    margin-top: -2%;
  }
}
@media (max-width: 690px) {
  .how__main .how_instructions .how_instructions_row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row {
    width: 90%;
    margin: 0 auto;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row .text_icon {
    font-size: 2rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text .text_row h2 {
    font-size: 1.8rem;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text p {
    width: 90%;
    font-size: 0.9rem;
    margin-left: 5%;
  }
  .how__main .how_instructions .how_instructions_row .how_row_text ul {
    width: 90%;
    font-size: 0.9rem;
    margin-left: 5%;
  }
  .how__main .how_instructions .how_instructions_row img {
    width: 100%;
  }
  .how__main .how_instructions .how_instructions_row:nth-child(even) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}
.how__main .how__tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  margin-top: 3%;
}
.how__main .how__tips h2 {
  width: 70%;
  margin: auto;
  text-align: center;
  font-size: 3rem;
  color: #e63b11;
}
.how__main .how__tips strong {
  font-size: 1.5rem;
  margin: 1% auto;
}
.how__main .how__tips .how_tips_row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 75%;
  margin: 2% auto;
}
.how__main .how__tips .how_tips_row h3 {
  color: #e63b11;
  font-size: 2.5rem;
}
.how__main .how__tips .how_tips_row h3 .tips_icon {
  height: 3rem;
}
.how__main .how__tips .how_tips_row .how_tips_row_text {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.how__main .how__tips .how_tips_row .how_tips_row_text p {
  font-size: 1.2rem;
}
.how__main .how__tips .how_tips_row .how_tips_row_text p span {
  color: #e63b11;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  .how__main .how__tips .how_tips_row {
    width: 90%;
  }
  .how__main .how__tips .how_tips_row h3 {
    font-size: 2rem;
    width: 50%;
  }
  .how__main .how__tips .how_tips_row .how_tips_row_text p {
    font-size: 1.1rem;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  .how__main .how__tips h2 {
    font-size: 2.3rem;
  }
  .how__main .how__tips strong {
    font-size: 1.2rem;
    width: 90%;
    text-align: center;
  }
  .how__main .how__tips .how_tips_row {
    width: 90%;
  }
  .how__main .how__tips .how_tips_row h3 {
    font-size: 2.1rem;
    width: 50%;
  }
  .how__main .how__tips .how_tips_row .how_tips_row_text p {
    font-size: 1rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  .how__main .how__tips h2 {
    font-size: 2.3rem;
  }
  .how__main .how__tips strong {
    font-size: 1.5rem;
    width: 90%;
    text-align: center;
  }
  .how__main .how__tips .how_tips_row {
    width: 90%;
  }
  .how__main .how__tips .how_tips_row h3 {
    font-size: 2.3rem;
    width: 50%;
  }
  .how__main .how__tips .how_tips_row .how_tips_row_text p {
    font-size: 1.2rem;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  .how__main .how__tips h2 {
    font-size: 2rem;
    width: 80%;
  }
  .how__main .how__tips strong {
    font-size: 1.2rem;
    text-align: center;
  }
  .how__main .how__tips .how_tips_row {
    width: 95%;
  }
  .how__main .how__tips .how_tips_row h3 {
    font-size: 1.5rem;
    width: 50%;
  }
  .how__main .how__tips .how_tips_row .how_tips_row_text p {
    font-size: 0.9rem;
  }
}
@media (max-width: 690px) {
  .how__main .how__tips h2 {
    font-size: 1.8rem;
    width: 90%;
  }
  .how__main .how__tips strong {
    font-size: 1rem;
    text-align: center;
    width: 95%;
  }
  .how__main .how__tips .how_tips_row {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .how__main .how__tips .how_tips_row img {
    margin-right: 3%;
  }
  .how__main .how__tips .how_tips_row h3 {
    font-size: 1.2rem;
    width: 100%;
  }
  .how__main .how__tips .how_tips_row h3 .tips_icon {
    height: 1.8rem;
  }
  .how__main .how__tips .how_tips_row .how_tips_row_text {
    width: 95%;
  }
  .how__main .how__tips .how_tips_row .how_tips_row_text p {
    font-size: 0.9rem;
  }
}
.how__main .how__tutorial {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f2f2f2;
}
.how__main .how__tutorial h2 {
  width: 70%;
  margin: 1% auto;
  text-align: center;
  font-size: 3rem;
  color: #e63b11;
}
.how__main .how__tutorial video {
  margin: 0 auto 2% auto;
}
@media (min-width: 691px) and (max-width: 850px) {
  .how__main .how__tutorial h2 {
    font-size: 2rem;
  }
}
@media (max-width: 690px) {
  .how__main .how__tutorial h2 {
    font-size: 1.8rem;
  }
  .how__main .how__tutorial video {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/how.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EC8BI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED/BA,WAAA;AAEJ;AAAI;EC0BA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED3BI,WAAA;AAKR;AAJQ;EACI,eAAA;AAMZ;AALY;EACI,cCXP;ADkBT;AAJQ;EACI,gBAAA;EACA,iBAAA;EACA,cAAA;AAMZ;AAJQ;ECiCJ,aAAA;EACA,mBAAA;EACA,6BAAA;EDjCQ,UAAA;EACA,cCtBH;EDuBG,eAAA;AAQZ;AAPY;EACI,yBAAA;EACA,iBAAA;AAShB;AANQ;EACI;IACI,eAAA;EAQd;EANU;IACI,iBAAA;EAQd;EALc;IACI,iBAAA;EAOlB;AACF;AAJQ;EACI;IACI,iBAAA;EAMd;EAJU;IACI,iBAAA;EAMd;EAHc;IACI,iBAAA;EAKlB;AACF;AAFQ;EAlDJ;IAmDQ,UAAA;IACA,kBAAA;EAKV;EAJU;IACI,iBAAA;EAMd;EAJU;IACI,iBAAA;EAMd;EAJU;IACI,UAAA;EAMd;EALc;IACI,iBAAA;EAOlB;EALc;IACI,eAAA;EAOlB;AACF;AAHI;EC5CA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED2CI,WAAA;AAQR;AAPQ;EACI,WAAA;ECfR,aAAA;EACA,mBAAA;EACA,8BAAA;ADyBJ;AAVY;EACI,YAAA;ECrCZ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;ADkDJ;AAdgB;ECRZ,aAAA;EACA,mBAAA;EACA,uBAAA;EDQgB,UAAA;AAkBpB;AAjBoB;EACI,iBAAA;AAmBxB;AAjBoB;EACI,cC3Ff;ED4Fe,eAAA;EACA,eAAA;AAmBxB;AAhBgB;EACI,UAAA;EACA,iBAAA;EACA,gBAAA;AAkBpB;AAhBgB;EACI,UAAA;EACA,iBAAA;EACA,gBAAA;AAkBpB;AAfY;EACI,UAAA;EACA,oBAAA;AAiBhB;AAfY;EACI,yBAAA;EACA,2BAAA;AAiBhB;AAdQ;EAGY;IACI,iBAAA;EActB;EAZkB;IACI,iBAAA;EActB;EAXc;IACI,YAAA;EAalB;AACF;AATQ;EAIgB;IACI,iBAAA;EAQ1B;EANsB;IACI,iBAAA;EAQ1B;EALkB;IACI,iBAAA;EAOtB;EALkB;IACI,iBAAA;EAOtB;AACF;AAHQ;EAIgB;IACI,iBAAA;EAE1B;EAAsB;IACI,iBAAA;EAE1B;EACkB;IACI,eAAA;EACtB;EACkB;IACI,eAAA;EACtB;AACF;AAGQ;EAGY;IACI,UAAA;EAHtB;EAIsB;IACI,eAAA;EAF1B;EAIsB;IACI,iBAAA;EAF1B;EAKkB;IACI,iBAAA;IACA,UAAA;IACA,aAAA;EAHtB;EAKkB;IACI,kBAAA;IACA,UAAA;IACA,eAAA;IACA,eAAA;EAHtB;AACF;AAOQ;EACI;IC1JR,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;EDsJF;EAIkB;IACI,UAAA;IACA,cAAA;EAFtB;EAGsB;IACI,eAAA;EAD1B;EAGsB;IACI,iBAAA;EAD1B;EAIkB;IACI,UAAA;IACA,iBAAA;IACA,eAAA;EAFtB;EAIkB;IACI,UAAA;IACA,iBAAA;IACA,eAAA;EAFtB;EAKc;IACI,WAAA;EAHlB;EAKc;ICrLZ,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;EDmLF;AACF;AAII;ECzMA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EDwMI,cAAA;AACR;AAAQ;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cChPH;ADkPT;AAAQ;EACI,iBAAA;EACA,eAAA;AAEZ;AAAQ;EChLJ,aAAA;EACA,uBAAA;EACA,8BAAA;EDgLQ,UAAA;EACA,eAAA;AAIZ;AAHY;EACI,cC3PP;ED4PO,iBAAA;AAKhB;AAJgB;EACI,YAAA;AAMpB;AAHY;EACI,UAAA;EC1OZ,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;ADgPJ;AAPgB;EACI,iBAAA;AASpB;AARoB;EACI,cCvQf;ADiRT;AALQ;EACI;IACI,UAAA;EAOd;EANc;IACI,eAAA;IACA,UAAA;EAQlB;EALkB;IACI,iBAAA;EAOtB;AACF;AAHQ;EACI;IACI,iBAAA;EAKd;EAHU;IACI,iBAAA;IACA,UAAA;IACA,kBAAA;EAKd;EAHU;IACI,UAAA;EAKd;EAJc;IACI,iBAAA;IACA,UAAA;EAMlB;EAHkB;IACI,eAAA;EAKtB;AACF;AADQ;EACI;IACI,iBAAA;EAGd;EADU;IACI,iBAAA;IACA,UAAA;IACA,kBAAA;EAGd;EADU;IACI,UAAA;EAGd;EAFc;IACI,iBAAA;IACA,UAAA;EAIlB;EADkB;IACI,iBAAA;EAGtB;AACF;AACQ;EACI;IACI,eAAA;IACA,UAAA;EACd;EACU;IACI,iBAAA;IACA,kBAAA;EACd;EACU;IACI,UAAA;EACd;EAAc;IACI,iBAAA;IACA,UAAA;EAElB;EACkB;IACI,iBAAA;EACtB;AACF;AAGQ;EACI;IACI,iBAAA;IACA,UAAA;EADd;EAGU;IACI,eAAA;IACA,kBAAA;IACA,UAAA;EADd;EAGU;ICzTR,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;EDyTF;EADc;IACI,gBAAA;EAGlB;EADc;IACI,iBAAA;IACA,WAAA;EAGlB;EAFkB;IACI,cAAA;EAItB;EADc;IACI,UAAA;EAGlB;EAFkB;IACI,iBAAA;EAItB;AACF;AACI;EC5VA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;ED2VI,yBAAA;AAIR;AAHQ;EACI,UAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cCnYH;ADwYT;AAHQ;EACI,sBAAA;AAKZ;AAHQ;EACI;IACI,eAAA;EAKd;AACF;AAHQ;EACI;IACI,iBAAA;EAKd;EAHU;IACI,WAAA;EAKd;AACF","sourcesContent":["@import './variables.scss';\n\n.how__main{\n    @include columnStartCenter;\n    padding: 1%;\n\n    .how_top_section{\n        @include columnStartCenter;\n        width: 100%;\n        h2{\n            font-size: 3rem;\n            span{\n                color: $orange;\n            }\n        }\n        h6{\n            font-weight: 400;\n            font-size: 1.8rem;\n            margin: 0 auto;\n        }\n        .how_top_section_row{\n            @include rowEven;\n            width: 50%;\n            color: $orange;\n            margin: 1% auto;\n            h3{\n                text-transform: uppercase;\n                font-size: 1.9rem;\n            }\n        }\n        @media(min-width: $tabletMin) and (max-width: $tabletMax){\n            h2{\n                font-size: 2rem;\n            }\n            h6{\n                font-size: 1.2rem;\n            }\n            .how_top_section_row{\n                h3{\n                    font-size: 1.3rem;\n                }\n            }\n        }\n        @media(min-width: $smallLaptopMin) and (max-width: $smallLaptopMax){\n            h2{\n                font-size: 2.3rem;\n            }\n            h6{\n                font-size: 1.5rem;\n            }\n            .how_top_section_row{\n                h3{\n                    font-size: 1.5rem;\n                }\n            }\n        }\n        @media(max-width: $mobile){\n            width: 90%;\n            text-align: center;\n            h2{\n                font-size: 1.8rem;\n            }\n            h6{\n                font-size: 1.2rem;\n            }\n            .how_top_section_row{\n                width: 90%;\n                h3{\n                    font-size: 1.2rem;\n                }\n                .how_icon{\n                    font-size: 1rem;\n                }\n            }\n        }\n    }\n    .how_instructions{\n        @include columnStartCenter;\n        width: 100%;\n        .how_instructions_row{\n            width: 100%;\n            @include rowBetween;\n            .how_row_text{\n                margin: auto;\n                @include columnCenter;\n                .text_row{\n                    @include rowCenter;\n                    width: 80%;\n                    .text_icon{\n                        font-size: 2.5rem;\n                    }\n                    h2{\n                        color: $orange;\n                        margin-left: 2%;\n                        font-size: 2rem;\n                    }\n                }\n                p{\n                    width: 70%;\n                    font-size: 1.2rem;\n                    margin-left: 12%;\n                }\n                ul{\n                    width: 50%;\n                    font-size: 1.2rem;\n                    margin-left: 12%;\n                }\n            }\n            img{\n                width: 50%;\n                filter: opacity(.6);\n            }\n            &:nth-child(even){\n                background-color: #f2f2f2;\n                flex-direction: row-reverse;\n            }\n        }\n        @media (min-width: $smallScreen) and (max-width: 1900px){\n            .how_instructions_row{\n                .how_row_text{\n                    p{\n                        font-size: 1.1rem;\n                    }\n                    ul{\n                        font-size: 1.1rem;\n                    }\n                }\n                img{\n                    height: 100%;\n                }\n    \n            }\n        }\n        @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax){\n            .how_instructions_row{\n                .how_row_text{\n                    .text_row{\n                        h2{\n                            font-size: 1.5rem;\n                        }\n                        .text_icon{\n                            font-size: 2.2rem;\n                        }\n                    }\n                    p{\n                        font-size: .9rem;\n                    }\n                    ul{\n                        font-size: .9rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $smallLaptopMin) and (max-width: $smallLaptopMax){\n            .how_instructions_row{\n                .how_row_text{\n                    .text_row{\n                        h2{\n                            font-size: 1.7rem;\n                        }\n                        .text_icon{\n                            font-size: 2.4rem;\n                        }\n                    }\n                    p{\n                        font-size: 1rem;\n                    }\n                    ul{\n                        font-size: 1rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $tabletMin) and (max-width: $tabletMax){\n            .how_instructions_row{\n                .how_row_text{\n                    .text_row{\n                        width: 95%;\n                        .text_icon{\n                            font-size: 2rem;\n                        }\n                        h2{\n                            font-size: 1.3rem;\n                        }\n                    }\n                    p{\n                        font-size: .9rem;\n                        width: 85%;\n                        margin-top: 0;\n                    }\n                    ul{\n                        font-size: .85rem;\n                        width: 95%;\n                        margin-left: 5%;\n                        margin-top: -2%;\n                    }\n                }\n            }\n        }\n        @media (max-width: $mobile){\n            .how_instructions_row{\n                @include columnCenter;\n                .how_row_text{\n                    .text_row{\n                        width: 90%;\n                        margin: 0 auto;\n                        .text_icon{\n                            font-size: 2rem;\n                        }\n                        h2{\n                            font-size: 1.8rem;\n                        }\n                    }\n                    p{\n                        width: 90%;\n                        font-size: .9rem;\n                        margin-left: 5%;\n                    }\n                    ul{\n                        width: 90%;\n                        font-size: .9rem;\n                        margin-left: 5%;\n                    }\n                }\n                img{\n                    width: 100%;\n                }\n                &:nth-child(even){\n                    @include columnCenter;\n                }\n            }\n        }\n    }\n    .how__tips{\n        @include columnStartCenter;\n        margin-top: 3%;\n        h2{\n            width: 70%;\n            margin: auto;\n            text-align: center;\n            font-size: 3rem;\n            color: $orange;\n        }\n        strong{\n            font-size: 1.5rem;\n            margin: 1% auto;\n        }\n        .how_tips_row{\n            @include rowBetweenStart;\n            width: 75%;\n            margin: 2% auto;\n            h3{\n                color: $orange;\n                font-size: 2.5rem;\n                .tips_icon{\n                    height: 3rem;\n                }\n            }\n            .how_tips_row_text{\n                width: 50%;\n                @include columnStart;\n                p{\n                    font-size: 1.2rem;\n                    span{\n                        color: $orange;\n                    }\n                }\n            }\n        }\n        @media (min-width: $smallScreen) and (max-width: 1900px){\n            .how_tips_row{\n                width: 90%;\n                h3{\n                    font-size: 2rem;\n                    width: 50%;\n                }\n                .how_tips_row_text{\n                    p{\n                        font-size: 1.1rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax){\n            h2{\n                font-size: 2.3rem;\n            }\n            strong{\n                font-size: 1.2rem;\n                width: 90%;\n                text-align: center;\n            }\n            .how_tips_row{\n                width: 90%;\n                h3{\n                    font-size: 2.1rem;\n                    width: 50%;\n                }\n                .how_tips_row_text{\n                    p{\n                        font-size: 1rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $smallLaptopMin) and (max-width: $smallLaptopMax){\n            h2{\n                font-size: 2.3rem;\n            }\n            strong{\n                font-size: 1.5rem;\n                width: 90%;\n                text-align: center;\n            }\n            .how_tips_row{\n                width: 90%;\n                h3{\n                    font-size: 2.3rem;\n                    width: 50%;\n                }\n                .how_tips_row_text{\n                    p{\n                        font-size: 1.2rem;\n                    }\n                }\n            }\n        }\n        @media(min-width: $tabletMin) and (max-width: $tabletMax){\n            h2{\n                font-size: 2rem;\n                width: 80%;\n            }\n            strong{\n                font-size: 1.2rem;\n                text-align: center;\n            }\n            .how_tips_row{\n                width: 95%;\n                h3{\n                    font-size: 1.5rem;\n                    width: 50%;\n                }\n                .how_tips_row_text{\n                    p{\n                        font-size: .9rem;\n                    }\n                }\n            }\n        }\n        @media (max-width: $mobile){\n            h2{\n                font-size: 1.8rem;\n                width: 90%;\n            }\n            strong{\n                font-size: 1rem;\n                text-align: center;\n                width: 95%;\n            }\n            .how_tips_row{\n                @include columnCenter;\n                img{\n                    margin-right: 3%;\n                }\n                h3{\n                    font-size: 1.2rem;\n                    width: 100%;\n                    .tips_icon{\n                        height: 1.8rem;\n                    }\n                }\n                .how_tips_row_text{\n                    width: 95%;\n                    p{\n                        font-size: .9rem;\n                    }\n                }\n            }\n        }\n    }\n    .how__tutorial{\n        @include columnStartCenter;\n        background-color: #f2f2f2;\n        h2{\n            width: 70%;\n            margin:1% auto;\n            text-align: center;\n            font-size: 3rem;\n            color: $orange;\n        }\n        video{\n            margin: 0 auto 2% auto;\n        }\n        @media(min-width: $tabletMin) and (max-width: $tabletMax){\n            h2{\n                font-size: 2rem;\n            }\n        }\n        @media(max-width: $mobile){\n            h2{\n                font-size: 1.8rem;\n            }\n            video{\n                width: 100%;\n            }\n        }\n    }\n}","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
